import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiurl } from "../Constants";

export const fetchFooterdetails = createAsyncThunk("footerdetails/fetchFooterdetails", async () => {
    const response = await axios.get(apiurl + "footerdetails");
    return response.data.data;
});

// Initial state
const initialState = {
    footerdetails: [], // Correct key here
    loading: false,
    status: "idle",
    error: null,
};

const fetchFooterdetailsSlice = createSlice({
    name: "footerdetails",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFooterdetails.pending, (state) => {
                state.loading = true;
                state.status = "loading";
            })
            .addCase(fetchFooterdetails.fulfilled, (state, action) => {
                state.loading = false;
                state.status = "succeeded";
                state.footerdetails = action.payload; 
            })
            .addCase(fetchFooterdetails.rejected, (state, action) => {
                state.loading = false;
                state.status = "failed";
                state.error = action.error.message;
            });
    },
});

export default fetchFooterdetailsSlice.reducer;
